import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchItemTypesThunk: any = createAsyncThunk<IBindBaseEntity[]>(
  `${prefix} fetchItemTypes`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getQuestionTypes();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch item types. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
